import React from 'react'
import me from '../assets/images/me.png'
import "react-loading-skeleton/dist/skeleton.css";
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'
import { motion } from "framer-motion";
import { useState } from 'react';
import { useEffect } from 'react';

export default function Home() {

    const [getResume,setResume] = useState(false)

    useEffect(() => {
        setInterval(() => {
            setResume(!getResume)
         }, 10000);
    })
    

  return (
    <motion.div 
        className='home'
        initial={{ x: 300, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        exit={{ x: 300, opacity: 0 }}
        transition={{
        type: "spring",
        stiffness: 260,
        damping: 20,
        }}
    >
        {/* LEFT */}
         <div className="left">
            <h1>Hello <span>.</span></h1>
            <div className="info">
                <span class="material-symbols-outlined">maximize</span>
                <div>
                    <h4>Badreddine Ibril👋</h4>
                    <p>Creative web developer <br /> from Morocco</p>
                </div>
            </div>
        </div>
        {/* IMAGE */}
        <div className="image" >
            <div>
                <img src={me} /> 
            </div>
        </div>
        {/* RIGHT */}
        <ul className="right">
            <li>2003</li>
            <li>Web Developer</li>
            <li>Full Stack</li>
        </ul>

        {/* DOWNLOAD RESUME */}
        <div className="resume" style={{left : getResume ? '1em' : '-7em'}}>
            <img src="https://bestanimations.com/media/ufos/661785383ufo-flying-saucer-animated-gif-image-11.gif" alt="" />
            <a href={require('../assets/images/Badreddine Ibril CV.pdf')} download><span class="material-symbols-outlined">download</span><p>Resume</p></a>
        </div>
    </motion.div>
  )
}
